import { SCardSelection } from '@avalara/skylab-sdk/react';
import type { Address } from '../../../../../types';

type ValidAddressConfirmationProps = {
  suggestedAddresses: {
    country: string;
    line1: string;
    line2: string;
    line3: string;
    city: string;
    region: string;
    postalCode: string;
  }[];
  setSelectedAddress: (address: Address) => void;
  selectedIndex: number;
  setSelectedIndex: (value: number) => void;
};

const ValidAddressConfirmation = ({
  suggestedAddresses,
  setSelectedAddress,
  selectedIndex,
  setSelectedIndex,
}: ValidAddressConfirmationProps) => {
  const confirmationTitle = 'Check the address';
  const userAddressLabel = 'Address as entered';
  const suggestedLabel = 'Suggested address';

  const selectItem = (index: number) => {
    setSelectedAddress(suggestedAddresses[index]);
    setSelectedIndex(index);
  };

  const selectedCountry =
    suggestedAddresses[suggestedAddresses.length - 1].country === 'US' ? 'U.S. Postal Service. ' : 'Canada Post. ';
  const confirmationSubtitle = `This address is different than the one suggested by the ${selectedCountry} `;
  return (
    <>
      <div slot='header' id='address-validation-dialog-title' data-ref='buy.address-validation.valid-address.header'>
        {confirmationTitle}
      </div>
      <div slot='body' data-ref='buy.address-validation.valid-address.body'>
        <p>{confirmationSubtitle}</p>
        <div
          data-ref='buy.address-validation.valid-address.content-container'
          className='address-validation-box-container pad-all-sm'
        >
          {suggestedAddresses.map((validateAddressAll, index) => {
            const suggestedAddressFirstLine = `${validateAddressAll?.line1}, ${validateAddressAll?.line2}`;
            const suggestedAddressSecondLine = `${validateAddressAll?.city},
              ${validateAddressAll?.region}, ${validateAddressAll.postalCode},
              ${validateAddressAll?.country}`;
            return (
              <SCardSelection
                key={`${validateAddressAll.line1}-${validateAddressAll.postalCode}-${index}`}
                class={`card-status-display ${selectedIndex === index ? 'active' : ''}`}
                data-ref={`buy.address-validation.valid-address.card-selection-${index}`}
              >
                <div slot='input'>
                  <input
                    data-ref={`buy.address-validation.valid-address.suggested-address-${index}.input`}
                    type='radio'
                    id={`suggestedAddress-${index}`}
                    name={`suggestedAddress-${index}`}
                    onChange={() => selectItem(index)}
                    checked={Boolean(selectedIndex === index)}
                  />
                  <label
                    data-ref={`buy.address-validation.valid-address.suggested-address-${index}.label`}
                    htmlFor='suggestedAddress'
                  >
                    {index === suggestedAddresses.length - 1 ? userAddressLabel : suggestedLabel}
                  </label>
                </div>
                <div
                  slot='description'
                  className='pad-all-sm'
                  data-ref={`buy.address-validation.valid-address.suggested-address-${index}.description`}
                >
                  <p>{suggestedAddressFirstLine}</p>
                  <p>{suggestedAddressSecondLine}</p>
                </div>
              </SCardSelection>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ValidAddressConfirmation;
